import React from 'react'

import { Link } from 'gatsby'

import { PageLinkType } from '@contracts/content/pageLinks'

import * as styles from './PageLink.module.scss'

import ArrowRight from '@icons/arrow-right-red.svg'
import ArrowRightWhite from '@icons/arrow-right-white.svg'

interface Props {
	data: PageLinkType
}

const PageLink: React.FunctionComponent<Props> = ({ data }) => {
	const [isHovered, setIsHovered] = React.useState<boolean>(false)
	const { label, link } = data

	const icon = isHovered ? <ArrowRightWhite className={styles.arrow} /> : <ArrowRight className={styles.arrow} />

	return (
		<div className={styles.link} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
			<Link to={link.link}>
				<span>{label}</span>
				{icon}
			</Link>
		</div>
	)
}

export default PageLink
